import React, {useEffect, useMemo, useState} from "react";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from "react-router-dom";
import { history } from "../../redux/store/configureStore";
import ClientsList from "./ClientsList";
import * as clientActions from "../../redux/actions/clientActions";
import * as studentActions from "../../redux/actions/studentActions";
import * as settingsActions from "../../redux/actions/settingsActions";
import {filterArray, getStudentsByClientId} from "../common/Helpers";
import Checkbox from "../common/Checkbox";
import {
  buildManageRouteWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";

export function Clients({
  clients,
  loadClients,
  showArchivedClients,
  toggleClientList,
  students,
  loadStudents,
  peopleViewState,
  onPeopleViewStateChange,
}) {
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const isPeopleViewStateControlled = Boolean(peopleViewState);
  const [search, setSearch] = useState((peopleViewState && peopleViewState.search) || '');
  const [showArchivedClientsLocal, setShowArchivedClientsLocal] = useState(Boolean(peopleViewState && peopleViewState.showArchived));
  const [clientsEx, setClientsEx] = useState([]);
  const effectiveShowArchivedClients = isPeopleViewStateControlled ? showArchivedClientsLocal : showArchivedClients;
  const clientsForSelectedArchive = useMemo(() => clients.filter(client => (
    effectiveShowArchivedClients ? client.archived : !client.archived
  )), [clients, effectiveShowArchivedClients]);

  useEffect(() => {
    if (clients.length === 0) {
      loadClients()
        .catch((error) => {
          alert(`Loading clients failed${error}`);
        });
    }

    if (students.length === 0) {
      loadStudents()
        .catch((error) => {
          alert(`Loading students failed${error}`);
        });
    }
  }, []);

  useEffect(() => {
    setClientsEx(clientsForSelectedArchive.map(client => ({...client, expanded: false, students: getStudentsByClientId(students, client.id)})));
  }, [clientsForSelectedArchive, students]);

  const handleEdit = (client) => {
    history.push(buildManageRouteWithSchoolYear(`/manage/client/${client.id}`, location.search, activeSchoolYearStartYear));
  };

  const handleExpand = (client) => {
    setClientsEx(clientsEx.map(c => (c.id === client.id ? {...client, expanded: !client.expanded} : c)));
  };

  const handleAdd = () => {
    history.push(buildManageRouteWithSchoolYear("/manage/client/new", location.search, activeSchoolYearStartYear));
  };

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    onPeopleViewStateChange({ search: value });
  };

  const filteredClients = filterArray(search, clientsEx);

  const handleArchivedClients = () => {
    if (isPeopleViewStateControlled) {
      const nextValue = !showArchivedClientsLocal;
      setShowArchivedClientsLocal(nextValue);
      onPeopleViewStateChange({ showArchived: nextValue });
      return;
    }
    toggleClientList();
  };

  return (
    <div className="mb-5">
      <h2 className="manage-title col-block mb-0">Lista klientów</h2>
      <div className="row d-flex align-items-center mx-0">
        <input name="search" className="form-control form-group col-md-5 col-8 pr-2" value={search} onChange={handleSearchChange} placeholder="szukaj"/>
        <div className="col-md-3 col-4 ">
          <Checkbox
            label="Archiwum"
            onChange={handleArchivedClients}
            name="showArchivedClients"
            isChecked={effectiveShowArchivedClients}
            textPosition="rightOnLarge"
          />
        </div>
        <div className="col-md-4 px-0">
          {!effectiveShowArchivedClients && (
            <button
              type="button"
              className="btn manage-button btn-success btn-block form-group"
              onClick={handleAdd}
            >
              Dodaj nowego klienta
            </button>
          )}
        </div>
      </div>
      <ClientsList
        clients={filteredClients}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onExpand={handleExpand}
        showArchivedClients={effectiveShowArchivedClients}
        initialNumToShow={peopleViewState ? peopleViewState.numToShow : 25}
        onNumToShowChange={numToShow => onPeopleViewStateChange({ numToShow })}
      />
    </div>
  );
}


Clients.propTypes = {
  clients: PropTypes.array.isRequired,
  students: PropTypes.array.isRequired,
  loadClients: PropTypes.func.isRequired,
  loadStudents: PropTypes.func.isRequired,
  showArchivedClients: PropTypes.bool.isRequired,
  toggleClientList: PropTypes.func.isRequired,
  peopleViewState: PropTypes.shape({
    search: PropTypes.string,
    showArchived: PropTypes.bool,
    numToShow: PropTypes.number,
  }),
  onPeopleViewStateChange: PropTypes.func,
};

Clients.defaultProps = {
  peopleViewState: null,
  onPeopleViewStateChange: () => {},
};

const mapStateToProps = (state) => {
  const showArchivedClients = state.settings.showArchivedClients;

  return ({
    clients: state.clients.filter(client => !client.deleted),
    showArchivedClients,
    students: state.students,
  });
};

const mapDispatchToProps = dispatch => ({
  loadClients: () => dispatch(clientActions.loadClients()),
  loadStudents: () => dispatch(studentActions.loadStudents()),
  toggleClientList: () => dispatch(settingsActions.toggleClientList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Clients);
